// Import Third-party libraries
import axios from 'axios'
import { getDistributorData } from './GetDistributor'

// Function to query agent's approved email ID
export const addAgent = (agentData, environment, is_trial, dispatch) => {
  let data = { agentData, env: environment, is_trial: is_trial }

  return new Promise((resolve, reject) => {
    axios
      .post(
        'https://hal-cos-prd-gwc-fnapp-v1.azurewebsites.net/api/addagent',
        data,
      )
      .then(async (response) => {
        // Using async to handle sequential actions
        let res = response.data
        if (res.success === 'success') {
          const resolvedAgentId =
            res.agentID ?? res.agent_id ?? res.agentId ?? res.AgentID
          const resolvedStoreId = Array.isArray(res.agentData?.StoreID)
            ? res.agentData.StoreID[0]
            : res.agentData?.StoreID

          dispatch({
            type: 'SET_AGENT_DATA',
            payload: {
              ...agentData,
              ...res.agentData,
              agent_id: resolvedAgentId,
              plan: res.agentData?.plan ?? agentData.plan,
            },
          })
          if (resolvedAgentId) {
            dispatch({ type: 'SET_AGENT_ID', payload: resolvedAgentId })
          }
          if (resolvedStoreId) {
            dispatch({ type: 'STORE_ID', payload: resolvedStoreId })
          }
          try {
            if (res.agentData?.DistributorID) {
              await getDistributorData(
                res.agentData.DistributorID,
                environment,
                is_trial,
                dispatch,
              )
            } else {
              return {}
            }
          } catch (error) {
            return {}
          }

          resolve(res) // Resolve after all actions complete
        } else {
          reject(new Error('Verification failed'))
        }
      })
      .catch((err) => {
        reject(err) // Reject on API failure
      })
  })
}
